import React from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import LoginLogout from './LoginLogout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
const CONTACT_US = 'https://www.nationalcityca.gov/services/advanced-components/contact-us/';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav" aria-label="Footer links">
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={CONTACT_US}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" aria-label="National City YouTube" href="https://www.youtube.com/channel/UCDHEFY3QBD3VU8VJKQ-113g">
            <FontAwesomeIcon icon={faYoutube}/>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" aria-label="National City Facebook" href="https://www.facebook.com/CityofNationalCity/">
            <FontAwesomeIcon icon={faFacebookF}/>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" aria-label="National City X" href="https://twitter.com/cityofnatlcity?lang=en">
            <FontAwesomeIcon icon={faXTwitter}/>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" aria-label="National City Instagram" href="https://www.instagram.com/cityofnationalcity/">
            <FontAwesomeIcon icon={faInstagram}/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
